module.exports = __webpack_public_path__ + "static/media/piano.e7b9b15a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/piano.jpg
// module id = 1486
// module chunks = 0